const styles = ({ palette, screenSizes }) => ({
  '& .error-region': {
    color: palette.error,
    marginTop: 10,
    textAlign: 'center',
  },
  background: palette.background,
  borderLeft: '4px solid #00dfeb',
  display: 'block',
  flexDirection: 'column',
  height: '100%',
  padding: 0,

  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    border: 'none',
    display: 'flex',
  },
});

export default styles;
